module.exports = __webpack_public_path__ + "img/50.8f52b55.png";